const actions = {
  MANAGER_DASHBOARD_BEGIN: "MANAGER_DASHBOARD_BEGIN",
  MANAGER_DASHBOARD_SUCCESS: "MANAGER_DASHBOARD_SUCCESS",
  MANAGER_DASHBOARD_ERR: "MANAGER_DASHBOARD_ERR",
  MANAGER_DASHBOARD_RESET: "MANAGER_DASHBOARD_RESET",

  MANAGER_PRICE_LIST_BEGIN: "MANAGER_PRICE_LIST_BEGIN",
  MANAGER_PRICE_LIST_SUCCESS: "MANAGER_PRICE_LIST_SUCCESS",
  MANAGER_PRICE_LIST_ERR: "MANAGER_PRICE_LIST_ERR",
  MANAGER_PRICE_LIST_RESET: "MANAGER_PRICE_LIST_RESET",

  MANAGER_MODEL_DISCOUNT_BEGIN: "MANAGER_MODEL_DISCOUNT_BEGIN",
  MANAGER_MODEL_DISCOUNT_SUCCESS: "MANAGER_MODEL_DISCOUNT_SUCCESS",
  MANAGER_MODEL_DISCOUNT_ERR: "MANAGER_MODEL_DISCOUNT_ERR",
  MANAGER_MODEL_DISCOUNT_RESET: "MANAGER_MODEL_DISCOUNT_RESET",

  FILE_UPLOAD_BEGIN: "FILE_UPLOAD_BEGIN",
  FILE_UPLOAD_SUCCESS: "FILE_UPLOAD_SUCCESS",
  FILE_UPLOAD_ERR: "FILE_UPLOAD_ERR",
  FILE_UPLOAD_RESET: "FILE_UPLOAD_RESET",

  MANAGER_DISCOUNT_CALCULATE_BEGIN: "MANAGER_DISCOUNT_CALCULATE_BEGIN",
  MANAGER_DISCOUNT_CALCULATE_SUCCESS: "MANAGER_DISCOUNT_CALCULATE_SUCCESS",
  MANAGER_DISCOUNT_CALCULATE_ERR: "MANAGER_DISCOUNT_CALCULATE_ERR",
  MANAGER_DISCOUNT_CALCULATE_RESET: "MANAGER_DISCOUNT_CALCULATE_RESET",

  MANAGER_GENERATE_OTP_BEGIN: "MANAGER_GENERATE_OTP_BEGIN",
  MANAGER_GENERATE_OTP_SUCCESS: "MANAGER_GENERATE_OTP_SUCCESS",
  MANAGER_GENERATE_OTP_ERR: "MANAGER_GENERATE_OTP_ERR",
  MANAGER_GENERATE_OTP_RESET: "MANAGER_GENERATE_OTP_RESET",

  MANAGER_VERIFY_OTP_BEGIN: "MANAGER_VERIFY_OTP_BEGIN",
  MANAGER_VERIFY_OTP_SUCCESS: "MANAGER_VERIFY_OTP_SUCCESS",
  MANAGER_VERIFY_OTP_ERR: "MANAGER_VERIFY_OTP_ERR",
  MANAGER_VERIFY_OTP_RESET: "MANAGER_VERIFY_OTP_RESET",

  MANAGER_SEND_REQUEST_BEGIN: "MANAGER_SEND_REQUEST_BEGIN",
  MANAGER_SEND_REQUEST_SUCCESS: "MANAGER_SEND_REQUEST_SUCCESS",
  MANAGER_SEND_REQUEST_ERR: "MANAGER_SEND_REQUEST_ERR",
  MANAGER_SEND_REQUEST_RESET: "MANAGER_SEND_REQUEST_RESET",

  MANAGER_HISTORY_BEGIN: "MANAGER_HISTORY_BEGIN",
  MANAGER_HISTORY_SUCCESS: "MANAGER_HISTORY_SUCCESS",
  MANAGER_HISTORY_ERR: "MANAGER_HISTORY_ERR",
  MANAGER_HISTORY_RESET: "MANAGER_HISTORY_RESET",

  MANAGER_VIEW_BEGIN: "MANAGER_VIEW_BEGIN",
  MANAGER_VIEW_SUCCESS: "MANAGER_VIEW_SUCCESS",
  MANAGER_VIEW_ERR: "MANAGER_VIEW_ERR",
  MANAGER_VIEW_RESET: "MANAGER_VIEW_RESET",

  MANAGER_ALTERNATIVE_METHOD_BEGIN: "MANAGER_ALTERNATIVE_METHOD_BEGIN",
  MANAGER_ALTERNATIVE_METHOD_SUCCESS: "MANAGER_ALTERNATIVE_METHOD_SUCCESS",
  MANAGER_ALTERNATIVE_METHOD_ERR: "MANAGER_ALTERNATIVE_METHOD_ERR",
  MANAGER_ALTERNATIVE_METHOD_RESET: "MANAGER_ALTERNATIVE_METHOD_RESET",

  getManagerDashboardBegin: () => ({
    type: actions.MANAGER_DASHBOARD_BEGIN,
  }),

  getManagerDashboardSuccess: (data) => ({
    type: actions.MANAGER_DASHBOARD_SUCCESS,
    data,
  }),

  getManagerDashboardErr: (err) => ({
    type: actions.MANAGER_DASHBOARD_ERR,
    err,
  }),

  getManagerDashboardReset: () => ({
    type: actions.MANAGER_DASHBOARD_RESET,
  }),

  getManagerPriceListBegin: () => ({
    type: actions.MANAGER_PRICE_LIST_BEGIN,
  }),

  getManagerPriceListSuccess: (data) => ({
    type: actions.MANAGER_PRICE_LIST_SUCCESS,
    data,
  }),

  getManagerPriceListErr: (err) => ({
    type: actions.MANAGER_PRICE_LIST_ERR,
    err,
  }),

  getManagerPriceListReset: () => ({
    type: actions.MANAGER_PRICE_LIST_RESET,
  }),

  getManagerModelDiscountBegin: () => ({
    type: actions.MANAGER_MODEL_DISCOUNT_BEGIN,
  }),

  getManagerModelDiscountSuccess: (data) => ({
    type: actions.MANAGER_MODEL_DISCOUNT_SUCCESS,
    data,
  }),

  getManagerModelDiscountErr: (err) => ({
    type: actions.MANAGER_MODEL_DISCOUNT_ERR,
    err,
  }),

  getManagerModelDiscountReset: () => ({
    type: actions.MANAGER_MODEL_DISCOUNT_RESET,
  }),

  fileUploadBegin: (fileType) => ({
    type: actions.FILE_UPLOAD_BEGIN,
    payload: { fileType },
  }),

  fileUploadSuccess: (data, fileType) => ({
    type: actions.FILE_UPLOAD_SUCCESS,
    payload: { data, fileType },
  }),

  fileUploadErr: (err, fileType) => ({
    type: actions.FILE_UPLOAD_ERR,
    payload: { err, fileType },
  }),

  resetFileUpload: () => ({
    type: actions.FILE_UPLOAD_RESET,
  }),

  managerDiscountCalculateBegin: () => ({
    type: actions.MANAGER_DISCOUNT_CALCULATE_BEGIN,
  }),

  managerDiscountCalculateSuccess: (data) => ({
    type: actions.MANAGER_DISCOUNT_CALCULATE_SUCCESS,
    data,
  }),

  managerDiscountCalculateErr: (err) => ({
    type: actions.MANAGER_DISCOUNT_CALCULATE_ERR,
    err,
  }),

  managerDiscountCalculateReset: () => ({
    type: actions.MANAGER_DISCOUNT_CALCULATE_RESET,
  }),

  managerGenerateOtpBegin: () => ({
    type: actions.MANAGER_GENERATE_OTP_BEGIN,
  }),

  managerGenerateOtpSuccess: (data) => ({
    type: actions.MANAGER_GENERATE_OTP_SUCCESS,
    data,
  }),

  managerGenerateOtpErr: (err) => ({
    type: actions.MANAGER_GENERATE_OTP_ERR,
    err,
  }),

  managerGenerateOtpReset: () => ({
    type: actions.MANAGER_GENERATE_OTP_RESET,
  }),

  managerVerifyOtpBegin: () => ({
    type: actions.MANAGER_VERIFY_OTP_BEGIN,
  }),

  managerVerifyOtpSuccess: (data) => ({
    type: actions.MANAGER_VERIFY_OTP_SUCCESS,
    data,
  }),

  managerVerifyOtpErr: (err) => ({
    type: actions.MANAGER_VERIFY_OTP_ERR,
    err,
  }),

  managerVerifyOtpReset: () => ({
    type: actions.MANAGER_VERIFY_OTP_RESET,
  }),

  managerSendRequestBegin: () => ({
    type: actions.MANAGER_SEND_REQUEST_BEGIN,
  }),

  managerSendRequestSuccess: (data) => ({
    type: actions.MANAGER_SEND_REQUEST_SUCCESS,
    data,
  }),

  managerSendRequestErr: (err) => ({
    type: actions.MANAGER_SEND_REQUEST_ERR,
    err,
  }),

  managerSendRequestReset: () => ({
    type: actions.MANAGER_SEND_REQUEST_RESET,
  }),

  getManagerHistoryBegin: () => ({
    type: actions.MANAGER_HISTORY_BEGIN,
  }),

  getManagerHistorySuccess: (data) => ({
    type: actions.MANAGER_HISTORY_SUCCESS,
    data,
  }),

  getManagerHistoryErr: (err) => ({
    type: actions.MANAGER_HISTORY_ERR,
    err,
  }),

  getManagerHistoryReset: () => ({
    type: actions.MANAGER_HISTORY_RESET,
  }),

  getManagerViewBegin: () => ({
    type: actions.MANAGER_VIEW_BEGIN,
  }),

  getManagerViewSuccess: (data) => ({
    type: actions.MANAGER_VIEW_SUCCESS,
    data,
  }),

  getManagerViewErr: (err) => ({
    type: actions.MANAGER_VIEW_ERR,
    err,
  }),

  getManagerViewReset: () => ({
    type: actions.MANAGER_VIEW_RESET,
  }),

  managerAlternativeMethodBegin: () => ({
    type: actions.MANAGER_ALTERNATIVE_METHOD_BEGIN,
  }),

  managerAlternativeMethodSuccess: (data) => ({
    type: actions.MANAGER_ALTERNATIVE_METHOD_SUCCESS,
    data,
  }),

  managerAlternativeMethodErr: (err) => ({
    type: actions.MANAGER_ALTERNATIVE_METHOD_ERR,
    err,
  }),

  managerAlternativeMethodReset: () => ({
    type: actions.MANAGER_ALTERNATIVE_METHOD_RESET,
  }),
};

export default actions;
